import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Admin from './AdminApp';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';

import "./public/stylesheets/global.less";
import "./public/stylesheets/fonts.less";

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Switch>
        <Route path="/admin"><Admin/></Route>
        <Route path="/"><App/></Route>
      </Switch>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
